export const htmlToText = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.innerText;
};

export const removeSpecialChars = (str) => {
    return str.replace(/[!@#$%^&*()~`+_={}|][:"';<>?/.,-]*/, "");
};
